module.exports = __webpack_public_path__ + "img/landing-carousel-1.4cf190c4.png";